import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '../../../node_modules/@angular/forms';
import { Router, ActivatedRoute } from '../../../node_modules/@angular/router';
import { JwtService, UserService, CommonService } from '@app/core';
import { environment } from '@env/environment';

function passwordConfirming(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const pwd = c.parent.get('password');
  const cpwd = c.parent.get('confirmPassword')
  if (!pwd || !cpwd) return;
  if (pwd.value !== cpwd.value) {
    return { invalid: true };
  }
}

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  userId: number;
  uuid: string;
  message: string;
  msgColor: string;
  asterik: string;
  loginMsg: string = '';
  is_ResetPaswordSuccess: boolean = false;
  isLinkValid: boolean = false;
  forgotPasswordLink: string = environment.ui_url + '/#/identity?link=forgotPassword';
  get cpwd() {
    return this.resetPasswordForm.get('confirmPassword');
  }
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private jwtService: JwtService,
    private userService: UserService,
    private commonService: CommonService,
    private route: ActivatedRoute) {
    this.createForm();
  }
  ngOnInit() {
    this.jwtService.destroyToken();
    this.userService.getTokenFromAuthServer().subscribe(
      data => {
        console.log('Token Saved');
      },
      err => {
        console.log('Unable to connect to API URL');
      }
    );
    this.route.queryParams.subscribe(params => {
      this.uuid = params['uuid'];
    });
    this.commonService.validateLink(this.uuid).subscribe(
      data => {
        this.userId = data.data.userId;
        this.isLinkValid = true;
      },
      err => {
        console.log('Unable to verify password link');
      }
    );
  }
  onPasswordChange() {
    this.resetPasswordForm.patchValue({
      confirmPassword: null
    });
  }
  cancel() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  resetPassword() {
    var formData = this.resetPasswordForm.value;
    var data = { "userId": this.userId, "password": formData.password };
    this.userService.resetPassword(data).subscribe(
      res => {
        this.is_ResetPaswordSuccess = true;
        this.message = res.message;
        this.msgColor = 'green';
        this.asterik = '*';
        this.loginMsg = '<span>Please click <a  href="' + environment.ui_url + '/#/login">here</a> to login.</span>';
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
      }
    );
  }
  getStatusColor() {
    return this.msgColor;
  }
  private createForm() {
    this.resetPasswordForm = this.formBuilder.group({
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(64),
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9]+$')
      ])),
      confirmPassword: ['', [Validators.required, passwordConfirming]]
    });
  }
}
